<header class=" fixed-top clearC">
    <div class="header-wrap">
        <div class="logo">
            <h4>DeliveryPal</h4>
        </div>


        <ul class="top-menu">
            <!-- <li class="list-menu">
             <button mat-button >Orders</button>
        </li>  -->
            <li class="list-menu">
                <button mat-button [routerLink]="['/activity']" routerLinkActive="active">Activity</button>
            </li>
           <li class="list-menu">
                <button mat-button [routerLink]="['/region-map']" routerLinkActive="active">Region Map</button>
            </li> 
            <li class="list-menu">
                <button mat-button [routerLink]="['/drivers']" routerLinkActive="active">Drivers</button>
            </li>
            <li class="list-menu">
                <button mat-button [routerLink]="['/restaurants']" routerLinkActive="active">Restaurants</button>
            </li>
            <li class="list-menu menu-btn">
                <button mat-button [routerLink]="['/accounts']" routerLinkActive="active">Accounts</button>
                <div class="sub-menu">
                    <ul>
                        <li [routerLink]="['/accounts/sales']">Sales</li>
                        <li [routerLink]="['/accounts/purchase']">Purchase</li>
                    </ul>
                </div>
            </li>
            <li class="list-menu menu-btn" *ngIf="role==3">
                <button mat-button [routerLink]="['/settings']" routerLinkActive="active">Settings</button>
                <div class="sub-menu">
                    <ul>
                        <li [routerLink]="['/settings/users']">Users</li>
                        <li [routerLink]="['/settings/fees']">Fees</li>
                        <!-- <li [routerLink]="['/settings/teritory']">Teritory</li> -->
                        <li [routerLink]="['/settings/regions']">Regions</li>
                    </ul>
                </div>
            </li>
            <li class="list-menu">
                <button mat-button [routerLink]="['/prospects']" routerLinkActive="active">Prospects</button>
            </li>
            <!-- <li class="list-menu">
             <button mat-button [routerLink]="['/shift-planner']" routerLinkActive="active">Shift Planner</button>
        </li>  -->
            <li class="list-menu menu-btn">
                <button [routerLink]="['/alerts']" mat-button routerLinkActive="active">Alerts</button>
                <div *ngIf="alertCount != 0" class="notify"></div>
            </li>
        </ul>



        <ul class="top-menu-log">
            <li>
                <button mat-button [matMenuTriggerFor]="logOut"> <span>{{userName}}</span>
                    <mat-icon>keyboard_arrow_down</mat-icon> </button>
                <mat-menu #logOut="matMenu">
                    <button mat-menu-item [routerLink]="['/change-password']">Change Password</button>
                    <button mat-menu-item (click)="onLogout()">Logout</button>
                </mat-menu>
            </li>
        </ul>



    </div>

</header>